import type { Role } from "@dishour/shared";
import { Navigate, Outlet, useLocation } from "react-router";
import { homePathFor, useSession } from "../lib/session.js";

export function RequireRole({ roles }: { roles: Role[] }) {
  const { data: me, isPending } = useSession();
  const location = useLocation();

  if (isPending) {
    return <p className="p-6 text-center text-stone-500">불러오는 중…</p>;
  }
  if (!me) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  if (!roles.includes(me.role)) {
    return <Navigate to={homePathFor(me.role)} replace />;
  }
  return <Outlet />;
}
